import { Button } from '../button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../dialog'

interface DeletePaymentJustificationModalProps {
  isDeleteModalOpen: boolean
  setIsDeleteModalOpen: (value: boolean) => void
  handleDeletePaymentJustification: () => Promise<void>
  isLoading: boolean
}

export function DeletePaymentJustificationModal({
  isLoading,
  isDeleteModalOpen,
  setIsDeleteModalOpen,
  handleDeletePaymentJustification,
}: DeletePaymentJustificationModalProps) {
  return (
    <Dialog open={isDeleteModalOpen} onOpenChange={setIsDeleteModalOpen}>
      <DialogContent className="h-auto max-w-96">
        <DialogHeader>
          <DialogTitle>Excluir documento?</DialogTitle>
          <DialogDescription>
            Tem certeza que deseja excluir o documento? Essa ação é
            irreversível.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <DialogClose asChild>
            <Button
              variant="tertiary"
              className="w-full"
              data-testid="payment-justification-delete-cancel-button"
            >
              Cancelar
            </Button>
          </DialogClose>

          <Button
            className="w-full"
            onClick={handleDeletePaymentJustification}
            disabled={isLoading}
            data-testid="payment-justification-delete-confirm-button"
            isSubmitting={isLoading}
          >
            Excluir
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
